module.exports = __webpack_public_path__ + "img/pikmin.1f4b9529.png";